define('app-ContactUs/settings',[],function () {
    return {
        container: '.contactUs',
        contactOptionLink: '.contactOptionLink',
        contactOptions: '.contactOptions',
        contactDetails: '.contactDetails',
        showAllContactOps: '.showAllContactOps'
    }
});
